// uploadReducer.js
import {
  UPLOAD_PROJECT_FILE_FAILURE,
  UPLOAD_PROJECT_FILE_REQUEST,
  UPLOAD_PROJECT_FILE_SUCCESS,
  CLEAR_UPLOADED_FILES,
  REMOVE_UPLOADED_FILE,
  UPLOAD_PROFILE_FILE_REQUEST,
  UPLOAD_PROFILE_FILE_SUCCESS,
  UPLOAD_PROFILE_FILE_FAILURE,
} from "../Actions/Actions";

const initialState = {
  isUploading: false,
  uploaded: [], // array of { document_id?, id?, file_name?, blob_path? }
  error: null,
};

const uploadReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case UPLOAD_PROJECT_FILE_REQUEST:
    case UPLOAD_PROFILE_FILE_REQUEST:
      return { ...state, isUploading: true, error: null };
    case UPLOAD_PROJECT_FILE_SUCCESS: {
      const item = payload?.data || payload;
      return {
        ...state,
        isUploading: false,
        uploaded: [...state.uploaded, item],
        error: null,
      };
    }
    case UPLOAD_PROFILE_FILE_SUCCESS: {
      const item = payload?.data || payload;
      return {
        ...state,
        isUploading: false,
        uploaded: [...state.uploaded, item],
        error: null,
      };
    }
    case UPLOAD_PROJECT_FILE_FAILURE:
    case UPLOAD_PROFILE_FILE_FAILURE:
      return { ...state, isUploading: false, error: payload };
    case CLEAR_UPLOADED_FILES:
      return { ...state, uploaded: [], error: null };
    case REMOVE_UPLOADED_FILE: {
      // payload may contain file_name or document_id; support several possible name keys
      const fileName = payload?.file_name;
      const docId = payload?.document_id;
      const slotIndex = payload?.slotIndex;
      return {
        ...state,
        uploaded: state.uploaded.filter((u) => {
          if (!u) return false;
          // if slotIndex provided, remove any uploaded entry that was marked with that _slotIndex
          if (typeof slotIndex === 'number' && typeof u?._slotIndex === 'number' && u._slotIndex === slotIndex) return false;
          const uName = u.file_name || u.fileName || u.filename || u.name;
          if (fileName && uName && uName === fileName) return false;
          if (docId && (u.document_id === docId || u.id === docId)) return false;
          return true;
        }),
        error: null,
      };
    }
    default:
      return state;
  }
};

export default uploadReducer;
